<template>
    <div class="newsCenter">
        <div class="borderLine borderTop newTitleBox yahei">新闻中心</div>
        <div class="borderLine list">
            <newsList :dataList="dataList"></newsList>
        </div>
        <div class="pager">
            <comPager :totalPages="total"></comPager>
        </div>
    </div>
</template>

<script>
import newsList from "./newsList";
import comPager from "../comPager";
export default {
    name: "newsCenter",
    data(){
        return{
            dataList:[{},{}],
            total:1,
        }
    },
    components:{
        newsList,
        comPager
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.newsCenter{
}
</style>